import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import api from "./request/api.js"; // 导入api接口
Vue.prototype.$api = api; // 将api挂载到vue的原型上

import vant from "./utils/vant";
import { Collapse, CollapseItem, Panel, Empty, NumberKeyboard, Overlay } from "vant";

Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Panel);
Vue.use(Empty);
Vue.use(NumberKeyboard);
Vue.use(Overlay);
Vue.use(vant);

import VueJsonp from "vue-jsonp";
Vue.use(VueJsonp);

Vue.prototype.$imgPath = process.env.VUE_APP_IMG_BASEURL;
Vue.prototype.$mapBackurl = process.env.VUE_APP_MAP_CALLBACKURL;
Vue.prototype.$userAdress = process.env.VUE_APP_USER_ADRESS;
Vue.prototype.$activityShare = process.env.VUE_APP_ACTIVITY_SHARE;
Vue.prototype.$activityBreak = process.env.VUE_APP_ACTIVITY_BREAK;

Vue.config.productionTip = false;

import "./permission"; // permission control

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
